export const PORTAL_ACCESS = {
  single_search: '1',
  bulk_search: '2',
  search_results: '3',
};

export const hasPortalAccess = (user, key) => {
  const booleans = user?.portal_access_booleans;
  if (booleans === undefined || booleans === null) return true;

  return String(booleans)
    .split(',')
    .map(value => value.trim())
    .filter(Boolean)
    .includes(PORTAL_ACCESS[key]);
};

export const firstAllowedPath = user => (hasPortalAccess(user, 'single_search') ? '/single_search' : '/bulk_search');
